import { AgCharts } from 'ag-charts-react';
import { colours } from '../../../StyleConstants';
import { Button, Paper } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useMemo } from 'react';

type Props = {
  data: any[];
  title: string;
  ddAvailable: boolean;
  imagingData: any;
  selectedSessionFilter?: string[];
}

const PieChart = ({ data, title, ddAvailable, imagingData, selectedSessionFilter }: Props) => {
    const navigate = useNavigate()
    const sessionFilteredRows = useMemo(() => {
        if(!selectedSessionFilter){
            return data;
        }
        const set = new Set(selectedSessionFilter);
        return data.filter(row => set.has(row.label));
    }, [data, selectedSessionFilter])
    return (
        <Paper
            elevation={5}
            sx={{
                marginBottom: "16px",
                borderRadius: 1,
                padding: 1
            }}
        >
            <AgCharts
                key={title}
                options={{
                    data: sessionFilteredRows,
                    title: {
                        text: title,
                        textAlign: 'left',
                        fontSize: 24,
                        fontWeight: 'bolder',
                        fontFamily: 'Libre Franklin'

                    },
                    background: {
                        fill: "transparent",
                    },
                    series: [
                        {
                            type: "pie",
                            angleKey: "value",
                            legendItemKey: "label",
                            fills: [
                                colours.categorical.one,
                                colours.categorical.two,
                                colours.categorical.three,
                                colours.categorical.four,
                                colours.categorical.five,
                                colours.categorical.six,
                                colours.categorical.seven,
                                colours.categorical.eight,
                                colours.categorical.nine,
                                colours.categorical.ten,
                            ],
                        },
                    ],
                    legend: {
                        position: "right", // Moves the legend to the left of the chart
                    },
                }} />
            {ddAvailable && !Object.keys(imagingData).includes(title) &&
          <Button
              sx={{ margin: 2 }}
              variant="outlined"
              onClick={() => {navigate("/data-wrangler", { state: { dictSearch: title } })}}
              onMouseDown={(e) => e.preventDefault()}
          >
            View Data Dictionary
          </Button>}
        </Paper>

    )
}

export default PieChart;
